/**
 * Angular imports.
 */
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';

/**
 * Directive imports.
 */
import { ModalDirective } from 'ngx-bootstrap/modal';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * Service imports.
 */
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';
import { PostApiService } from '../../dataservices/post-api.service';

/**
 * Product Follow Component
 */
@Component({
  selector: 'app-product-follow',
  templateUrl: './product-follow.component.html',
  styleUrls: ['./product-follow.component.scss']
})
export class ProductFollowComponent implements OnInit, OnDestroy {
  @ViewChild('autoShownModal') autoShownModal: ModalDirective;
  @Output() resetFollow = new EventEmitter();
  @Input() followObj;
  public isErrorModalShown = false;
  public isConfirmModalShown = false;
  public error_msg: string;
  public confirmInfo: string;
  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Necessary instances.
   */
  constructor(
    public funCollectionService: FunCollectionService,
    private productFollowService: PostApiService,
    public mls: MultiLangService
  ) { }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    if (this.followObj.status == 0) {
      this.follow();
    } else {
      this.confirmInfo = this.mls.Are_you_sure_you_want_to_unfollow_this_case;
      this.isConfirmModalShown = true;
    }
  }

  /**
   * follow
   */
  follow(): void {
    this.subscriptions.add(this.productFollowService.caseFollow(this.followObj['feed_id']).subscribe(data => {
      if (data.status === 1) {
        this.resetFollow.emit(data.data.status);
      } else {
        this.isErrorModalShown = true;
        this.ErrorHandler(data['error'].msg);
      }
    },
      err => {
        this.httpErrorHandeler(err);
      }));
  }

  /**
   * reset Error Modal
   */
  resetErrorModal(): void {
    this.isErrorModalShown = false;
    this.resetFollow.emit('error');

  }

  /**
   * reset confirm modal
   */
  resetConfirmModal(confirmAction): void {
    this.confirmInfo = '';
    this.isConfirmModalShown = false;
    if (confirmAction === true) {
      this.follow();
    } else {
      this.resetFollow.emit(this.followObj.status);
    }

  }

  /**
   * Error Handler
   */
  ErrorHandler(Err_msg): boolean {
    this.isErrorModalShown = true;
    this.error_msg = Err_msg;
    return false;
  }

  /**
   * http Error Handler
   */
  httpErrorHandeler(err): boolean {
    if (err.error.code == 2000) {
      this.ErrorHandler(err.error.error.msg);
      return false;
    } else if (err.error.error.code == 1002) {
      this.funCollectionService.logout();
    } else {
      this.ErrorHandler(err.error.error.msg);
      return false;
    }
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
